import * as React from "react";
import { GetCommitmentUsageTranscoded_getCommitmentUsageReportTranscoded } from "./__generated__/GetCommitmentUsageTranscoded";
import { GetCommitmentUsageViewed_getCommitmentUsageReportViewed } from "./__generated__/GetCommitmentUsageViewed";
import OrganizationCommitmentUsageDataContent from "./OrganizationCommitmentUsageDataContent";

export type CommitmentUsageTab = "transcoded" | "viewed";

interface Props {
    selectedTab: CommitmentUsageTab;
    onSelectTab: (tab: CommitmentUsageTab) => void;
    loadingTranscoded: boolean;
    loadingViewed: boolean;
    includeBillingInGb: boolean;
    transcodedData?: GetCommitmentUsageTranscoded_getCommitmentUsageReportTranscoded;
    viewedData?: GetCommitmentUsageViewed_getCommitmentUsageReportViewed;
    hasSearched: boolean;
}

export default function OrganizationCommitmentUsageData({
    selectedTab,
    onSelectTab,
    loadingTranscoded,
    loadingViewed,
    includeBillingInGb,
    transcodedData,
    viewedData,
    hasSearched,
}: Props) {
    if (!hasSearched) {
        return <div style={{ marginTop: "10px" }}>Select a date range and hit the search button</div>;
    }

    return (
        <OrganizationCommitmentUsageDataContent
            selectedTab={selectedTab}
            onSelectTab={onSelectTab}
            includeBillingInGb={includeBillingInGb}
            transcodedData={transcodedData}
            viewedData={viewedData}
            loadingTranscoded={loadingTranscoded}
            loadingViewed={loadingViewed}
        />
    );
}
